import {useState, useEffect} from 'react';

import Cloud1 from '../assets/img/cloud1.png';
import Cloud2 from '../assets/img/cloud2.png';
import Skyline from '../assets/img/skyline.png';
import Logo from '../assets/img/exp-logo-dark.png';

import { useParallax } from 'react-scroll-parallax';

const Hero = (props: {
  cta: Function;
}) => {
  const {ref} = useParallax({ speed: -10 });

  const [isLoaded, setIsLoaded] = useState(false);

  const handleViewListingClick = () => {
    window.open('https://samuelbebeau.exprealty.com/', '_blank'); 
  }

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 500);
  }, []);

  return (
    <section className="hero">
      <div className="cloud one" style={{backgroundImage: `url(${Cloud1})`}} />
      <div className="cloud two" style={{backgroundImage: `url(${Cloud2})`}} />
      <article ref={ref} className={isLoaded ? 'in' : ''}>
        <img src={Logo} alt="" />
        <h1><span className="sans"></span>in Austin,TX</h1>
        <button className="btn" onClick={handleViewListingClick}>View Listings</button>
      </article>
      <div className="skyline" style={{backgroundImage: `url(${Skyline})`}} />
    </section>
  );
}

export default Hero;
